import request from '@/utils/http'

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

export const addFavorite = (addFavoriteData) => {
    // const data = {
    //     userId,
    //     articleId,
    //     columnId,
    //     title,
    //     columnName,
    //     summary,
    // };
    return request.requestPost(BASE_URL+"portal/favorite/add",addFavoriteData)
};

export const delFavorite = (userId,articleId) => {
    const delFavoriteData = {
        userId,
        articleId,
    }
    // return request.requestPost(BASE_URL+"portal/favorite/del?userId="+userId+"&articleId="+articleId)
    return request.requestPost(BASE_URL+"portal/favorite/del",delFavoriteData)
};

export const delFavoriteById = (id) => {
    const delFavoriteData = {
        id
    }
    return request.requestPost(BASE_URL+"portal/favorite/del",delFavoriteData)
};

export const checkFavoriteList = (userId) => {
    return request.requestPost(BASE_URL+"portal/favorite/list?userId="+userId)
};

export const getFavoriteList = (userId,pageNum,pageSize) => {
    return request.requestPost(BASE_URL+"portal/favorite/list?userId="+userId+"&pageNum="+pageNum+"&pageSize="+pageSize)
};
